import React from "react";

import moment from "moment";
import "moment/locale/pt";

moment.locale("pt");

export default class MomentFromNow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: moment(props.time).fromNow()
    };
  }

  componentDidMount() {
    this.timerID = setInterval(
      () => this.tick(),
      1000
    );
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  tick = () => {
    this.setState({
      date: moment(this.props.time).fromNow()
    });
  };

  render() {
    return this.state.date;
  }
}